module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACBSURBVHgBhZDRDYAgDETRCRzBERzBTXQEN9BNdANHcARHcAQ/SaB6lgSMBBoJDSR9ba+ntEZtCZt7Ve64JAeIcBiDJgEAVPbC7iCOU4YIq4fAt8uO4+olQNx1zGuymL5QmRClwvu/VRHleJM5VPO4QRRpCL24JmtoY1HeKNGDP6sfCn6nOZAy5/UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-arrow-right.png
// module id = 6ppL
// module chunks = 1